import { Clapperboard } from 'lucide-react'
import { mediaShowModule } from '../podcast/engine/moduleDefinition'

/** F-178 Vídeos: shows of video episodes, on the same engine as Podcast. */
export const videosModule = mediaShowModule('videos', Clapperboard, 'clapperboard')
